/**
 * @generated SignedSource<<0077d349529f0452139b8ffabdc9a345>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateCertificatesRewardButton_CertificateTemplatesConnectionV2Fragment$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
    };
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "CreateCertificatesRewardButton_CertificateTemplatesConnectionV2Fragment";
};
export type CreateCertificatesRewardButton_CertificateTemplatesConnectionV2Fragment$key = {
  readonly " $data"?: CreateCertificatesRewardButton_CertificateTemplatesConnectionV2Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreateCertificatesRewardButton_CertificateTemplatesConnectionV2Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreateCertificatesRewardButton_CertificateTemplatesConnectionV2Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CertificateTemplatesEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CertificateTemplate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CertificateTemplatesConnection",
  "abstractKey": null
};

(node as any).hash = "917fd5edb9bb8336f8668bc21575265f";

export default node;
